import { AlgoliaIndiceName } from '@packages/common';

import { SearchBase } from './searchBase';

const attributesToRetrieve = ['objectID'];

export interface ExcludedPartner {
  objectID: string;
}

export function excludedPartnersSearch(searchBase: SearchBase) {
  return searchBase<ExcludedPartner>(AlgoliaIndiceName.EXCLUDED_PARTNERS, {
    attributesToRetrieve,
    hitsPerPage: 1000,
  });
}
